export default __webpack_public_path__ + "static/media/react-movie-logo.42955eb6.svg";